import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div>
      <Helmet>
        <title>Kontakt - Novurem Patisserie</title>
        <meta name="description" content="Kontaktieren Sie Novurem Patisserie in Ettlingen. Telefon, E-Mail, Adresse und Kontaktformular." />
      </Helmet>

      <section className="page-header">
        <div className="container">
          <h1>Kontakt</h1>
          <p>Wir freuen uns auf Ihre Nachricht.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div>
              <div className="contact-card">
                <div className="contact-icon"><FaPhone /></div>
                <div>
                  <h3>Telefon</h3>
                  <p>+4977081869489</p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-icon"><FaEnvelope /></div>
                <div>
                  <h3>E-Mail</h3>
                  <p><a href="mailto:novurem@hotmail.com">novurem@hotmail.com</a></p>
                </div>
              </div>
              <div className="contact-card">
                <div className="contact-icon"><FaHome /></div>
                <div>
                  <h3>Adresse</h3>
                  <p>Zehntwiesenstraße 33, 76275 Ettlingen<br />Deutschland</p>
                </div>
              </div>
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <h3 style={{ color: '#7b1e3a', marginBottom: '10px' }}>Besuchen Sie unsere Manufaktur</h3>
                <p style={{ fontSize: '14px' }}>Wir freuen uns auf Ihren Besuch und heißen Sie mit einer kostenlosen Kostprobe willkommen.</p>
              </div>
            </div>
            <div>
              <div className="checkout-form" style={{ padding: '30px' }}>
                <h2 style={{ color: '#7b1e3a', marginBottom: '20px', fontSize: '26px' }}>Schreiben Sie uns</h2>
                {submitted && (
                  <div style={{ background: '#9bc184', color: '#fff', padding: '15px', borderRadius: '10px', marginBottom: '15px' }}>
                    Vielen Dank! Ihre Nachricht wurde erfolgreich versendet.
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Ihr Name"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">E-Mail</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="Ihre E-Mail-Adresse"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Nachricht</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      placeholder="Ihre Nachricht an uns"
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">Nachricht senden</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}